import {
  CLEAR_REPORT_ANALYTICS,
  SET_ANALYTICS_REPORTS_COUNT,
  ADD_REPORT_ANALYTICS_PRODUCTS_LIST,
  UPDATE_REPORT_ANALYTICS_SELECTED_PRODUCT,
  SET_REPORT_ANALYTICS_DATE_RANGE,
  SET_REPORT_ANALYTICS_SEARCH_TEXT,
  RESET_REPORT_ANALYTICS_FILTERS,
  APPLY_REPORT_ANALYTICS_FILTERS, APPLY_REPORT_ANALYTICS_FILTERS_FROM_URL,
  SET_REPORT_ANALYTICS_PAGE_OPTIONS, FETCH_REPORT_ANALYTICS_LOADING, FETCH_REPORT_ANALYTICS_ERROR, FETCH_REPORT_ANALYTICS_SUCCESS,
  FETCH_STATEFARM_DASHBOARD_SUCCESS,
  FETCH_STATEFARM_DASHBOARD_LOADING,
  FETCH_STATEFARM_DASHBOARD_ERROR,
  UPDATE_LOCAL_STATEFARM_FILTER,
  UPDATE_APPLIED_STATEFARM_FILTER,
  RESET_STATEFARM_FILTER,
} from 'constants/ActionTypes';
import {
  isDateRangeValid, getLastYearRange,
  DATE_RANGES,
} from 'features/orderHistory/components/filters/commonComponents/dateRangeFilter/DateFilter.utils';
import { prepareStatefarmData } from './components/analytics/Analytics.utils';

const [defaultStartDate, defaultEndDate] = getLastYearRange();

const initReportAnalyticsFilters = {
  searchText: '',
  reportType: '',
  selectedDateOption: DATE_RANGES.LAST_YEAR,
  startDate: defaultStartDate,
  endDate: defaultEndDate,
  dateError: false,
  selectedProduct: null,
};

const initialState = {
  reportsCount: null,
  reportAnalytics: [],
  statefarmDashboardData: [],
  statefarmFilteredData: [],
  stateFarmLocalFilters: {
    action: 'all',
    reportId: '',
    email: '',
  },
  stateFarmAppliedFilters: {
    action: 'all',
    reportId: '',
    email: '',
  },
  pageNumber: 1,
  pageSize: 10,
  reportAnalyticsFilters: initReportAnalyticsFilters,
  appliedReportAnalyticsFilters: initReportAnalyticsFilters,
  productsList: [],
  loading: {
    reportAnalytics: false,
    statefarmDashboard: false,
  },
  error: {
    reportAnalytics: false,
    statefarmDashboard: false,
  },
  successTimestamp: {
    reportAnalytics: null,
  },
};

export default function reducer(state = initialState, action = {}) {
  let loadingKey = '';
  let errorKey = '';
  switch (action.type) {
    case FETCH_REPORT_ANALYTICS_SUCCESS:
      return {
        ...state,
        reportAnalytics: action.data,
        loading: { ...state.loading, reportAnalytics: false },
        error: { ...state.error, reportAnalytics: false },
        successTimestamp: { ...state.successTimestamp, reportAnalytics: Date.now() },
        reportAnalyticsFilters: state.appliedReportAnalyticsFilters,
      };
    case FETCH_STATEFARM_DASHBOARD_SUCCESS: {
      const hasNoAppliedFilters = state.stateFarmAppliedFilters.action === 'all'
        && state.stateFarmAppliedFilters.reportId === ''
        && state.stateFarmAppliedFilters.email === '';

      const preparedData = prepareStatefarmData(action.data);

      return {
        ...state,
        statefarmDashboardData: preparedData,
        statefarmFilteredData: hasNoAppliedFilters ? preparedData : state.statefarmFilteredData,
        loading: { ...state.loading, statefarmDashboard: false },
        error: { ...state.error, statefarmDashboard: false },
      };
    }
    case ADD_REPORT_ANALYTICS_PRODUCTS_LIST: return { ...state, productsList: action.productsList };
    case SET_REPORT_ANALYTICS_SEARCH_TEXT: return {
      ...state,
      reportAnalyticsFilters: {
        ...state.reportAnalyticsFilters,
        searchText: action.searchText,
      },
    };
    case SET_REPORT_ANALYTICS_DATE_RANGE: {
      const startDate = action.startDate ?? state.reportAnalyticsFilters.startDate;
      const endDate = action.endDate ?? state.reportAnalyticsFilters.endDate;
      const dateError = isDateRangeValid(startDate, endDate);
      return {
        ...state,
        reportAnalyticsFilters: {
          ...state.reportAnalyticsFilters,
          startDate,
          endDate,
          dateError,
          selectedDateOption: action.selectedDateOption,
        },
      };
    }
    case SET_REPORT_ANALYTICS_PAGE_OPTIONS: return { ...state, ...action.pageOptions };
    case UPDATE_REPORT_ANALYTICS_SELECTED_PRODUCT: return {
      ...state,
      reportAnalyticsFilters: {
        ...state.reportAnalyticsFilters,
        selectedProduct: action.selectedProduct,
      },
    };
    case APPLY_REPORT_ANALYTICS_FILTERS: return { ...state, appliedReportAnalyticsFilters: state.reportAnalyticsFilters };
    case APPLY_REPORT_ANALYTICS_FILTERS_FROM_URL: return {
      ...state,
      reportAnalyticsFilters: action.filters,
      appliedReportAnalyticsFilters: action.filters,
    };
    case RESET_REPORT_ANALYTICS_FILTERS: return {
      ...state,
      reportAnalyticsFilters: initReportAnalyticsFilters,
      appliedReportAnalyticsFilters: initReportAnalyticsFilters,
    };
    case UPDATE_LOCAL_STATEFARM_FILTER: return {
      ...state,
      stateFarmLocalFilters: {
        ...state.stateFarmLocalFilters,
        [action.key]: action.value,
      },
    };
    case UPDATE_APPLIED_STATEFARM_FILTER: return {
      ...state,
      stateFarmAppliedFilters: {
        ...state.stateFarmLocalFilters,
      },
      statefarmFilteredData: action.filteredData,
    };
    case FETCH_REPORT_ANALYTICS_LOADING: loadingKey = 'reportAnalytics'; break;
    case FETCH_REPORT_ANALYTICS_ERROR: errorKey = 'reportAnalytics'; break;
    case FETCH_STATEFARM_DASHBOARD_LOADING: loadingKey = 'statefarmDashboard'; break;
    case FETCH_STATEFARM_DASHBOARD_ERROR: errorKey = 'statefarmDashboard'; break;
    case SET_ANALYTICS_REPORTS_COUNT: return { ...state, reportsCount: action.count };
    case CLEAR_REPORT_ANALYTICS: return initialState;
    case RESET_STATEFARM_FILTER: return {
      ...state,
      stateFarmLocalFilters: initialState.stateFarmLocalFilters,
      stateFarmAppliedFilters: initialState.stateFarmAppliedFilters,
      statefarmFilteredData: state.statefarmDashboardData,
    };
    default: return state;
  }
  if (loadingKey) return { ...state, loading: { ...state.loading, [loadingKey]: true }, error: { ...state.error, [loadingKey]: false } };
  if (errorKey) return { ...state, loading: { ...state.loading, [errorKey]: false }, error: { ...state.error, [errorKey]: true } };
  return state;
}
